import OddsFormatDropdownLegacy from './OddsFormatDropdownLegacy';

export default OddsFormatDropdownLegacy;
